{
	"content": {
		"declarationDetailsSection": {
			"title": "Podrobnosti prohlášení",
			"description": "K vytvoření prohlášení je potřeba jméno zákazníka, adresa a země držitele prohlášení. Informace nelze dodatečně změnit.",
			"customerLabel": "Zákaznický účet"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Uveďte podrobnosti prohlášení",
			"alertDescription": "Údaje, které poskytnete, budou trvale zaznamenány v prohlášení a nelze je poté měnit.",
			"projectLabel": "Reference projektu",
			"companyNameLabel": "Název společnosti",
			"streetLabel": "Ulice",
			"zipCodeLabel": "PSČ",
			"cityLabel": "Město",
			"countryLabel": "Země"
		}
	},
	"summary": {
		"title": "Shrnutí",
		"declarationTypeTitle": "Typ prohlášení",
		"customerProjectTitle": "Zákaznický projekt",
		"internalProjectOrProductTitle": "Interní projekt / produkt",
		"projectReferenceTitle": "Reference projektu",
		"materialHeaderTitle": "Materiál",
		"quantityHeaderTitle": "Množství ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Přidělitelné snížení uhlíku ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Nepřidělitelné snížení uhlíku ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Je vyžadována reference projektu",
		"companyNameRequired": "Název společnosti je povinný",
		"streetRequired": "Ulice je povinná",
		"zipCodeRequired": "Je vyžadováno PSČ",
		"cityRequired": "Město je povinné",
		"countryRequired": "Země je povinná",
		"customerRequired": "Zákazník je vyžadován"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Přezkoumání souhrnu prohlášení",
		"description": "Zkontrolujte prosím, zda zadaná data neobsahují chyby.",
		"alertDescription": "Informace, které jste uvedli, budou trvale zaznamenány v prohlášení a nelze je poté měnit.",
		"typeSectionTitle": "1. Typ",
		"declarationTypeLabel": "Typ prohlášení",
		"customerProjectTitle": "Zákaznický projekt",
		"internalProjectOrProductTitle": "Interní projekt / produkt",
		"projectReferenceLabel": "Reference projektu",
		"materialSectionTitle": "2. Materiál",
		"materialHeaderTitle": "Materiál",
		"quantityHeaderTitle": "Množství ({{unit}})",
		"totalCarbonReductionsLabel": "Celkové snížení uhlíku ({{unit}})",
		"declarationSectionTitle": "3. Prohlášení",
		"companyNameLabel": "Název společnosti",
		"streetLabel": "Ulice",
		"zipCodeLabel": "PSČ",
		"cityLabel": "Město",
		"countryLabel": "Země",
		"backTitle": "Zpět",
		"submitTitle": "Ano, vše je správně"
	},
	"submitTitle": "Vytvořit prohlášení",
	"backTitle": "Zpět"
}
